import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-instructor-viewer',
  templateUrl: './instructor-viewer.component.html',
  styleUrls: ['./instructor-viewer.component.scss']
})
export class InstructorViewerComponent {
  url: string = '';

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.url = params['url'];
    });
  }
}
